import { lazy } from "react";
import { Navigate } from "react-router-dom";

const Opportunities = lazy(() => import("pages/OpportunitiesV2/Overview/Opportunities"));
const OpportunityDetails = lazy(() => import("pages/OpportunitiesV2/Details/OpportunityDetails"));

export const opportunities = [
  {
    path: "opportunities",
    element: <Navigate to="overview" replace />,
  },
  {
    path: "opportunities",
    children: [
      {
        path: "overview",
        element: <Opportunities />,
      },
      {
        path: "details",
        element: <OpportunityDetails />,
      },
    ],
  },
];
